import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Grid, Button, Typography, TextField, InputAdornment, IconButton } from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import CloseIcon from "@mui/icons-material/Close";
import EditIcon from "@mui/icons-material/Edit";
import DragHandleIcon from "@mui/icons-material/DragHandle";
import DeleteIcon from "@mui/icons-material/Delete";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import DoneIcon from "@mui/icons-material/Done";
import uuid from "react-uuid";
import { filterObjectsUptoCategory, timestamp } from "../../../utils/services";

const AddLocationMultiple = (props) => {
  const {
    open,
    setOpen,
    lineName,
    cmtLocHolder,
    locationData,
    isPlaceHolder,
    item,
    AllCategoryList,
    categoryId,
    lineId,
    lineInputControlId,
    nonHT,
    updateTemplate,
    action = "",
    commentId,
    locationValue,
    setAllCategoryList,
    onApplySelection,
  } = props;
  const unique_id = uuid();
  const dispatch = useDispatch();
  const categories = useSelector((state) => state.templates)?.categoryList;
  let locationDataArray = [];
  if (locationData !== undefined) {
    locationDataArray =
      locationData.length > 0 &&
      locationData?.map((el, index) => {
        return {
          id: index + 1,
          value: el.value,
          order: el.order,
          uuid: el.uuid,
          col: el.col,
        };
      });
  }

  const [locationTextArray, setLocationTextArray] = useState(locationValue);
  const [locationInput, setLocationInput] = useState(Array.isArray(locationValue) ? locationValue.map(x => x.name).join(", ") : locationValue);
  const [locationArray, setLocationArray] = useState(locationDataArray);
  const [editLocation, setEditLocation] = useState(false);
  let columnOneData = locationArray.length > 0 && locationArray?.filter((e) => e.col === "1");
  let columnTwoData = locationArray.length > 0 && locationArray?.filter((e) => e.col === "2");
  let columnThreeData = locationArray.length > 0 && locationArray?.filter((e) => e.col === "3");
  const [columnOne, setColumnOne] = useState(columnOneData);
  const [columnTwo, setColumnTwo] = useState(columnTwoData);
  const [columnThree, setColumnThree] = useState(columnThreeData);

  // generating unique id values on each changes
  const updateLocationData = () => {
    let locationCopyArray = [...locationArray];
    let updatedLocationData = locationCopyArray?.map((location, index) => {
      return {
        id: index + 1,
        value: location.value,
        order: location.order,
        uuid: location.uuid,
        col: location.col,
      };
    });
    setLocationArray(updatedLocationData);
  };

  const addLocationTextToArray = (id, name) => {
    let tempTextArray = Array.isArray(locationTextArray) ? [...locationTextArray] : !locationTextArray ? [] : locationTextArray;
    let idsArray = tempTextArray?.map((obj) => obj.id);
    if (idsArray?.includes(id)) {
      let selectedLocationIndex = idsArray?.findIndex((el) => el == id);
      if (selectedLocationIndex !== -1) tempTextArray.splice(selectedLocationIndex, 1);
    } else tempTextArray?.push({ id, name });
    setLocationTextArray(tempTextArray);
    syncInputFromArray(tempTextArray);
  };

  useEffect(() => {
    if (open) {
      setLocationTextArray(parseInputToArray(locationInput));
    }
  }, [open, locationArray]);

  const hasUUID = (array, id) => {
    let newArray = array;
    if (!Array.isArray(newArray))
      newArray = newArray?.split(",")
    return newArray?.some((item) => item.id === id);
  };


  const syncInputFromArray = (arr) => {
    setLocationInput(arr?.map(x => x.name)?.join(", "));
  };

  const parseInputToArray = (input) => {
    const names = input?.split(",")?.map(s => s.trim())?.filter(Boolean);
    // de-dup (case-insensitive)
    const seen = new Set();
    const unique = names?.filter(n => {
      const k = n?.toLowerCase();
      if (seen.has(k)) return false;
      seen.add(k);
      return true;
    });

    // Try to reuse ids from master list or current selection, else new uuid
    return unique?.map(name => {
      const matchInMaster = (locationArray || [])?.find(
        l => (l.value || "").trim().toLowerCase() === name.toLowerCase()
      );
      const matchInCurrent = (Array.isArray(locationTextArray) ? locationTextArray : locationTextArray.split(",")).find(
        l => (l.name || "").trim().toLowerCase() === name.toLowerCase()
      );
      return { id: matchInMaster?.uuid || matchInCurrent?.id || uuid(), name };
    });
  };


  const locationEdithandle = (value, id) => {
    let editTempArray = [...locationArray];
    let editObj = editTempArray.find((e) => e.uuid === id);
    editObj.value = value;
    let validArray = editTempArray.filter((temp) => {
      return temp.value?.trim().length !== 0;
    });
    setLocationArray(editTempArray);
  };

  const deleteLocationHandle = (id) => {
    let deleteTempArray = [...locationArray];
    let deleteObjIndex = deleteTempArray.findIndex((e) => e.uuid === id);
    if (deleteObjIndex !== -1) deleteTempArray.splice(deleteObjIndex, 1);
    setLocationArray(deleteTempArray);
    setColumnOne(deleteTempArray.filter((e) => e.col === "1"));
    setColumnTwo(deleteTempArray.filter((e) => e.col === "2"));
    setColumnThree(deleteTempArray.filter((e) => e.col === "3"));
  };

  const addNewLocationHandle = (column, row) => {
    updateLocationData();
    let addLocTempArray = [...columnOne, ...columnTwo, ...columnThree];
    addLocTempArray.push({
      id: addLocTempArray.length + 1,
      value: "",
      uuid: uuid(),
      order: String(row + 1),
      col: String(column),
    });
    setLocationArray(addLocTempArray);
    setColumnOne(addLocTempArray.filter((e) => e.col === "1"));
    setColumnTwo(addLocTempArray.filter((e) => e.col === "2"));
    setColumnThree(addLocTempArray.filter((e) => e.col === "3"));
  };

  const handleEditLocationComplete = () => {
    const ValArray = locationArray.filter((val) => {
      return val.value?.trim().length !== 0;
    });
    setLocationArray(ValArray);
    setEditLocation(false);
  };

  const handleEditLocationStart = () => {
    const ValArray = locationArray.filter((val) => {
      return val.value?.trim().length !== 0;
    });
    setColumnOne(
      columnOne.filter((value) => {
        return value.value?.trim().length !== 0;
      })
    );
    setColumnTwo(
      columnTwo.filter((value) => {
        return value.value?.trim().length !== 0;
      })
    );
    setColumnThree(
      columnThree.filter((value) => {
        return value.value?.trim().length !== 0;
      })
    );
    setLocationArray(ValArray);
    setEditLocation(true);
  };
  const reorder = (data, startIndex, endIndex) => {
    const result = Array.from(data);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    return result;
  };

  const onDragEndHandle = (result, column) => {
    if (column === "colOne") setColumnOne(reorder(columnOne, result.source.index, result.destination.index));
    else if (column === "colTwo") setColumnTwo(reorder(columnTwo, result.source.index, result.destination.index));
    else if (column === "colThree") setColumnThree(reorder(columnThree, result.source.index, result.destination.index));
  };

  const handleLocationChanges = () => {
    let finalLocationArray = [...columnOne, ...columnTwo, ...columnThree];
    const removeEmpty = finalLocationArray.filter((location) => {
      return location.value !== "";
    });
    let lineIndex = null;
    let locationIndex = null;
    const catList = Array.isArray(AllCategoryList?.template?.categories) ? AllCategoryList.template.categories : [];
    const globalLoc = AllCategoryList?.template || {};
    const categoriesDataIndex = Array.isArray(catList) ? catList.findIndex((cat) => cat.category_id === categoryId) : -1;
    let locData = [];
    locationTextArray.map((locs) => {
      locData.push(locs.name);
    });
    let removeBracs = locData.toString();
    if (action === "comment") {
      // Lightweight mode: when used from Add Comment flow without template context
      if (typeof onApplySelection === "function" && (!AllCategoryList || !categoryId)) {
        onApplySelection(locationTextArray);
        setOpen(false);
        return;
      }
      if (categoriesDataIndex !== -1) {
        lineIndex = catList[categoriesDataIndex].lines.findIndex((line) => line.line_id === lineId);
        const isLocAvailable = catList[categoriesDataIndex].lines[lineIndex].comments.find((item) => item.comment_id === commentId).comment_input_controls.some((item) => item.type === "Location");
        if (!isLocAvailable) {
          cmtLocHolder[0].data = removeBracs;
          globalLoc.location_data = removeEmpty;
          catList[categoriesDataIndex].lines[lineIndex].comments.find((item) => item.comment_id === commentId).default_location = locationTextArray;
          catList[categoriesDataIndex].lines[lineIndex].comments.find((item) => item.comment_id === commentId).updated_at = timestamp();
          catList[categoriesDataIndex].lines[lineIndex].comments.find((item) => item.comment_id === commentId).comment_input_controls.push(cmtLocHolder[0]);
          catList[categoriesDataIndex].lines[lineIndex].comments.find((item) => item.comment_id === commentId).updated_at = timestamp();
        } else {
          globalLoc.location_data = removeEmpty;
          catList[categoriesDataIndex].lines[lineIndex].comments.find((item) => item.comment_id === commentId).comment_input_controls.find((item) => item.type === "Location").data = removeBracs;
          catList[categoriesDataIndex].lines[lineIndex].comments.find((item) => item.comment_id === commentId).comment_input_controls.find((item) => item.type === "Location").updated_at = timestamp();
          catList[categoriesDataIndex].lines[lineIndex].comments.find((item) => item.comment_id === commentId).default_location = locationTextArray;
          catList[categoriesDataIndex].lines[lineIndex].comments.find((item) => item.comment_id === commentId).updated_at = timestamp();
        }
      }
    } else {
      if (categoriesDataIndex !== -1) {
        lineIndex = catList[categoriesDataIndex].lines.findIndex((line) => line.line_id === lineId);
        if (isPlaceHolder) {
          item.data = removeBracs;
          globalLoc.location_data = removeEmpty;
          catList[categoriesDataIndex].lines[lineIndex].default_location = locationTextArray;
          catList[categoriesDataIndex].lines[lineIndex].updated_at = timestamp();
          locationIndex = catList[categoriesDataIndex].lines[lineIndex].line_input_controls.push(item);
          locationIndex = catList[categoriesDataIndex].lines[lineIndex].updated_at = timestamp();
        } else {
          locationIndex = catList[categoriesDataIndex].lines[lineIndex].line_input_controls.findIndex((info) => info.line_input_control_id === lineInputControlId);
          catList[categoriesDataIndex].lines[lineIndex].line_input_controls[locationIndex].data = removeBracs;
          globalLoc.location_data = removeEmpty;
          catList[categoriesDataIndex].lines[lineIndex].default_location = locationTextArray;
          catList[categoriesDataIndex].lines[lineIndex].updated_at = timestamp();
        }
      }
    }
    setOpen(false);
    filterObjectsUptoCategory(catList, categoryId, dispatch, categories);
    updateTemplate("noToast");
  };

  return (
    <Dialog className="dialog-container-location" open={open} onClose={() => setOpen(false)} fullWidth={true}>
      <div className="close-wrapper">
        <CloseIcon onClick={() => setOpen(false)} />
      </div>
      <DialogTitle>
        {!nonHT ? !editLocation ? (
          <>
            {`Location - ${lineName}`}
            <Typography>This will edit locations for the entire template.</Typography>
          </>
        ) : (
          <>
            Edit template location list
            <Typography>This will edit locations for the entire template.</Typography>
          </>
        ) : ""}
      </DialogTitle>
      {!editLocation && (
        <Grid className="input-dialog">
          <Grid className="input-controll">
            <p>DEFAULT LOCATION</p>
            <TextField
              fullWidth
              size="small"
              value={locationInput}
              onChange={(e) => {
                const v = e.target.value;
                setLocationInput(v);
                setLocationTextArray(parseInputToArray(v));
              }}
              onBlur={() => setLocationTextArray(parseInputToArray(locationInput))}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                  setLocationTextArray(parseInputToArray(locationInput));
                }
                if (e.key === "Escape") {
                  // optional: clear with Esc
                  setLocationInput("");
                  setLocationTextArray([]);
                }
              }}
              InputProps={{
                endAdornment: locationInput ? (
                  <InputAdornment position="end">
                    <IconButton
                      edge="end"
                      size="small"
                      aria-label="clear locations"
                      onClick={() => {
                        setLocationInput("");
                        setLocationTextArray([]);
                      }}
                    >
                      <ClearIcon fontSize="small" />
                    </IconButton>
                  </InputAdornment>
                ) : null,
              }}
            />
          </Grid>
        </Grid>
      )}
      <DialogContent className="dialog-content-location">
        {!editLocation ? (
          <Grid container>
            <Grid item xs={12} sm={4} md={4} className="loc-item-wrapper">
              {columnOne.length > 0 &&
                columnOne?.map((item, index) => {
                  return (
                    <div
                      style={{
                        display: item.value === "" && "none",
                        backgroundColor: hasUUID(locationTextArray, item.uuid) && "#eaf5ff",
                      }}
                      className="loc-item"
                      onClick={() => addLocationTextToArray(item.uuid, item.value)}
                    // style={{ background:`${item.status?'#EAF5FF':''}`}} key={index}
                    >
                      {item.value}
                    </div>
                  );
                })}
            </Grid>
            <Grid item xs={12} sm={4} md={4} className="loc-item-wrapper">
              {columnTwo.length > 0 &&
                columnTwo?.map((item, index) => {
                  return (
                    <div
                      style={{
                        display: item.value === "" && "none",
                        backgroundColor: hasUUID(locationTextArray, item.uuid) && "#eaf5ff",
                      }}
                      className="loc-item"
                      onClick={() => addLocationTextToArray(item.uuid, item.value)}
                    // style={{ background:`${item.status?'#EAF5FF':''}`}} key={index}
                    >
                      {item.value}
                    </div>
                  );
                })}
            </Grid>
            <Grid item xs={12} sm={4} md={4} className="loc-item-wrapper">
              {columnThree.length > 0 &&
                columnThree?.map((item, index) => {
                  return (
                    <div
                      style={{
                        display: item.value === "" && "none",
                        backgroundColor: hasUUID(locationTextArray, item.uuid) && "#eaf5ff",
                      }}
                      className="loc-item"
                      onClick={() => addLocationTextToArray(item.uuid, item.value)}
                    // style={{ background:`${item.status?'#EAF5FF':''}`}} key={index}
                    >
                      {item.value}
                    </div>
                  );
                })}
            </Grid>
          </Grid>
        ) : (
          <Grid container>
            <DragDropContext
              onDragEnd={(result) => {
                onDragEndHandle(result, "colOne");
              }}>
              <Droppable droppableId="colOne">
                {(provided) => (
                  <Grid item xs={12} sm={4} md={4} className="loc-item-wrapper" ref={provided.innerRef}>
                    {columnOne.map((item, index) => {
                      return (
                        <Draggable draggableId={String(item.id)} key={item.id} index={index}>
                          {(provided) => (
                            <div className="edit-loc-wrapper" key={index} ref={provided.innerRef} {...provided.dragHandleProps} {...provided.draggableProps}>
                              <DragHandleIcon className="drag-handle-icon" />
                              <input type="text" value={item.value} onChange={(e) => locationEdithandle(e.target.value, item.uuid)} />
                              <DeleteIcon className="loc-delete-icon" onClick={() => deleteLocationHandle(item.uuid)} />
                            </div>
                          )}
                        </Draggable>
                      );
                    })}
                    {provided.placeholder}
                    <div className="isFlex add-cta">
                      <span onClick={() => addNewLocationHandle("1", columnOne.length)}>
                        <AddCircleOutlineIcon /> Add new location
                      </span>
                    </div>
                  </Grid>
                )}
              </Droppable>
            </DragDropContext>
            <DragDropContext
              onDragEnd={(result) => {
                onDragEndHandle(result, "colTwo");
              }}>
              <Droppable droppableId="colTwo">
                {(provided) => (
                  <Grid item xs={12} sm={4} md={4} className="loc-item-wrapper" ref={provided.innerRef}>
                    {columnTwo.map((item, index) => {
                      return (
                        <Draggable draggableId={String(item.id)} key={item.id} index={index}>
                          {(provided) => (
                            <div className="edit-loc-wrapper" key={index} ref={provided.innerRef} {...provided.dragHandleProps} {...provided.draggableProps}>
                              <DragHandleIcon className="drag-handle-icon" />
                              <input type="text" value={item.value} onChange={(e) => locationEdithandle(e.target.value, item.uuid)} />
                              <DeleteIcon className="loc-delete-icon" onClick={() => deleteLocationHandle(item.uuid)} />
                            </div>
                          )}
                        </Draggable>
                      );
                    })}
                    {provided.placeholder}
                    <div className="isFlex add-cta">
                      <span onClick={() => addNewLocationHandle("2", columnTwo.length)}>
                        <AddCircleOutlineIcon /> Add new location
                      </span>
                    </div>
                  </Grid>
                )}
              </Droppable>
            </DragDropContext>
            <DragDropContext
              onDragEnd={(result) => {
                onDragEndHandle(result, "colThree");
              }}>
              <Droppable droppableId="colThree">
                {(provided) => (
                  <Grid item xs={12} sm={4} md={4} className="loc-item-wrapper" ref={provided.innerRef}>
                    {columnThree.map((item, index) => {
                      return (
                        <Draggable draggableId={String(item.id)} key={item.id} index={index}>
                          {(provided) => (
                            <div className="edit-loc-wrapper" key={index} ref={provided.innerRef} {...provided.dragHandleProps} {...provided.draggableProps}>
                              <DragHandleIcon className="drag-handle-icon" />
                              <input type="text" value={item.value} onChange={(e) => locationEdithandle(e.target.value, item.uuid)} />
                              <DeleteIcon className="loc-delete-icon" onClick={() => deleteLocationHandle(item.uuid)} />
                            </div>
                          )}
                        </Draggable>
                      );
                    })}
                    {provided.placeholder}
                    <div className="isFlex add-cta">
                      <span onClick={() => addNewLocationHandle("3", columnThree.length)}>
                        <AddCircleOutlineIcon /> Add new location
                      </span>
                    </div>
                  </Grid>
                )}
              </Droppable>
            </DragDropContext>
          </Grid>
        )}
      </DialogContent>

      <Grid>
        {!nonHT ? !editLocation ? (
          <Button className="location-edit-btn" variant="outlined" startIcon={<EditIcon />} onClick={() => handleEditLocationStart()}>
            Edit {!nonHT && "template"} location list
          </Button>
        ) : (
          <Button className="location-edit-btn" variant="outlined" startIcon={<DoneIcon />} onClick={() => handleEditLocationComplete()} style={{ marginBottom: "10px" }}>
            Done editing
          </Button>
        ) : ""}
      </Grid>
      {!editLocation && (
        <DialogActions className="dialog-action-location">
          <Button
            className="back-btn"
            onClick={() => {
              setOpen(false);
              const reset = Array.isArray(locationValue) ? locationValue : [];
              setLocationTextArray(reset);
              setLocationInput(reset.map(x => x.name).join(", "));
            }}>
            Cancel
          </Button>
          <Button className="default-btn" onClick={handleLocationChanges}>
            Apply
          </Button>
        </DialogActions>
      )}
    </Dialog>
  );
};

export default AddLocationMultiple;